// extracted by mini-css-extract-plugin
export var chevron = "_od-1";
export var clickable = "_od-0";
export var ruleRow = "_od-2";